import React from 'react';

import { HStack, Icon, Text } from '@betterment/samba-react';

import { HouseholdAccountsQuery } from './graphql/query.householdAccounts.generated';
import { accountHasSbloc, hasPendingAction } from './utils';

type EnvelopeAccount = HouseholdAccountsQuery['household']['accounts'][number];

interface AccountStatus {
  label: string;
  show: boolean;
}

export const AccountStatusIndicators: React.FC<{ account: EnvelopeAccount }> = ({ account }) => {
  const statuses: AccountStatus[] = [
    {
      label: 'Active SBLOC',
      show: accountHasSbloc(account),
    },
    {
      label: 'Rebalancing in progress',
      show: hasPendingAction(account, 'RebalanceNowPendingAction'),
    },
    {
      label: 'Migration in progress',
      show: hasPendingAction(account, 'PortfolioMigrationPendingAction'),
    },
  ].filter(status => status.show);

  if (statuses.length === 0) {
    return null;
  }

  return (
    <>
      {statuses.map(status => (
        <HStack key={status.label} css={{ gap: 'space.0' }}>
          <Icon name="InfoFilled" size="xsmall" color="icon.weak" />
          <Text variant="text50" color="text.weak">
            {status.label}
          </Text>
        </HStack>
      ))}
    </>
  );
};
